import { useLocation } from "react-router-dom";
import { ProjetoConfig } from "./Projeto/ProjetoConfig";
import { AcabamentosConfig } from "./Acabamentos/Acabamentos.config";
import { CNCConfig } from "./CNC/CNC.config";
import { TratamentoConfig } from "./Tratamento/Tratamento.config";
import { SerroteConfig } from "./Serrote/Serrote.config";
import { ConvencionaisConfig } from "./Convencionais/Convencionais.config";
import Entity from "../../Common/Entity";


export default function OperacoesWrapper() {

    const location = useLocation();
    const currentRoute = location.pathname;
    const obraId = currentRoute.split("/")[2];
    const pecaId = currentRoute.split("/")[4];
    const operationType = currentRoute.split("/")[6];
    const operationId = currentRoute.split("/")[7];

    const getTableConfig = () => {
        switch(operationType) {
            case 'Projeto':
                return ProjetoConfig;
            case 'Acabamento':
                return AcabamentosConfig;
            case 'CNC':
                return CNCConfig;
            case 'Tratamento':
                return TratamentoConfig;
            case 'Serrote':
                return SerroteConfig;
            case 'Convencionais':
                return ConvencionaisConfig;
        }


    } 


    
    return (<>
        <Entity
        defaultTableConfig={getTableConfig()}
            useAbsoluteRoute={true}
        />
        </>
    )

}